import { Component, HostBinding, Inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Dropdown } from '@app/models/interfaces/Dropdown';
import { Chip, ChipModel } from '@app/models/Chip';
import { TfNotificationsService } from '@app/modules/tf-notifications';
import { TfUserDataService } from '@app/modules/tf-user-data';
import { StoreService } from '@app/services/store.service';
import { SaveToListType } from "@app/modules/tf-shared-list";
import { PriceService, PricingModel } from "@app/modules/tf-pricing";
import { TfCartService } from '@app/modules/tf-cart';
import { Subscription} from 'rxjs';
import { Router } from '@angular/router';
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap/popover/popover";
import { AnalyticsService } from '@app/services/analytics.service';
import { ProductSiteRegionService } from '@app/services/product-site-region.service';
import { GEProductInterface } from "@app/products/ge/assays/models/interfaces/ge-product.interface";
import { TfCopyPayloadOptions } from "@app/modules/tf-copy-to-clipboard/types/copyPayloadOptions.type";
import { DOCUMENT } from "@angular/common";
import { TfBiozWidgetService } from "@app/modules/bioz";
import { makeDropdownOption } from '@app/functions/make-dropdown-option';
import {FisherSciCartItem, FisherSciCartRequest, FsCartService} from '@app/modules/fs-cart';


@Component({
    selector: 'tf-search-result-row',
    templateUrl: './search-result-row.component.html',
    styleUrls: ['./search-result-row.component.scss']
})
export class TfSearchResultRowComponent implements OnInit, OnDestroy, OnChanges {

    tabs = [{
        active: true,
        name: "General",
        type: "assay"
    }, {
        active: false,
        name: "Genome Map",
        type: "assay"
    }, {
        active: false,
        name: "Interrogated Sequences",
        type: "assay"
    }]

    chipDetails: Chip[] = [
        new ChipModel({
            name: 'Citations',
            label: 'Citations',
            active: false,
            show: true,
        }),
        new ChipModel({
            name: 'Details',
            label: 'Details',
            active: false,
            show: true,
        }),
        new ChipModel({
            name: 'Plate layout',
            label: 'Plate layout',
            active: false,
            show: true,
        }),
        new ChipModel({
            name: 'Related products',
            label: 'Related products',
            active: false,
            show: true,
        }),
    ];

    @Input() product: GEProductInterface = null;

    @Input()
    relatedArraysCount: number;

    @Input() isPriceLoading: boolean;

    @Input() index: number = 0;

    isUserLoggedIn: boolean;
    assayToSharedList: SaveToListType = null;
    selectedDye: Dropdown = null;
    selectedSize: Dropdown = null;
    selectedCatalogNum: string = '';
    selectedAvailabity: string = '';
    userSubscription: Subscription;

    pricing: PricingModel = null;

    showAssayIdCopyToClipboard = false;
    showCatalogNumberCopyToClipboard = false;
    timeOutHolder = null;

    selectedChip: string = null;
    showRelatedArraysChip: boolean = false;
    isAddableToCart:boolean= true;
    cartResponseMessage:string="";
    scrollToTab: string | undefined = undefined;
    isFisherSci: boolean = false;

    // Bioz Citations
    showCitationsChip: boolean = false;
    citationsCount: number = null;

    private subscriptions: Subscription = new Subscription();

    @ViewChild("detailsViewContainer", {read: ViewContainerRef}) detailsViewContainer: ViewContainerRef;
    @ViewChild("relatedProductsViewContainer", {read: ViewContainerRef}) relatedProductsViewContainer: ViewContainerRef;
    @ViewChild("biozViewContainer", {read: ViewContainerRef}) biozViewContainer: ViewContainerRef;

    @HostBinding('class.selected') selected: boolean = false;

    constructor(
        private storeService: StoreService,
        private biozWidgetService: TfBiozWidgetService,
        private tfNotificationsService: TfNotificationsService,
        private userDataSrv: TfUserDataService,
        private tfCartService: TfCartService,
        private priceService: PriceService,
        private analyticsService: AnalyticsService,
        private router: Router,
        private readonly productSiteRegionService: ProductSiteRegionService,
        private fsCartService: FsCartService,
        @Inject(DOCUMENT) private document: Document
    ) {

    }

    ngOnInit(): void {

        if (this.productSiteRegionService.isFisherSci()) {
            this.isFisherSci = true;
        }

        this.subscribeToLoginData();
        this.getBiozCitationsData();
        this.subscribeToSelectedResults();

        this.isPriceLoading = true;

        this.priceService.getPreloadedPricing(this.product.defaultCatalogNum).subscribe((data) => {
            this.pricing = data;
            this.isPriceLoading = false;
        });

        this.selectedCatalogNum = this.product.selectedCatalogNumber;
        this.selectedAvailabity = this.product.availability;
        this.selectedDye = makeDropdownOption(this.product.defaultDye, this.product.defaultDye, this.product.availability);
        this.selectedSize = makeDropdownOption(this.product.defaultCatalogNum, this.product.defaultSize, this.product.availability);
        this.setListItem();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["relatedArraysCount"].currentValue) {
            this.checkChipVisibility()
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    private subscribeToSelectedResults(): void {

        const resultsSubscription = this.storeService.selectedResults$.subscribe((results) => {

            if (results === null) {
                return;
            }

            const products = results.products || [];

            this.selected = products.includes(this.product);

        });

        this.subscriptions.add(resultsSubscription);

    }

    subscribeToLoginData() {

        const subscription = this.userDataSrv.getUserDetailsObservable().subscribe((userDetails) => {
            this.isUserLoggedIn = userDetails.isLoggedIn;
        });

        this.subscriptions.add(subscription);

    }

    getBiozCitationsData() {

        const subscription = this.biozWidgetService.getCitationsData(this.product.productID).subscribe((biozRecord) => {
            this.citationsCount = parseInt(biozRecord.total, 10);
            this.showCitationsChip = this.citationsCount > 0;
        });

        this.subscriptions.add(subscription);

    }

    setListItem(): void {
        this.assayToSharedList = {
            "src": "Taqman SERP",
            "itemId": this.selectedCatalogNum,
            "qty": 1,
            "designId": this.product.productID,
            "productType": this.product.productType,
            "productSubType": this.product.productSubType,
        }
    }

    toggleResultSection(chipName: string): void {

        if (chipName === 'Related arrays') {
            void this.router.navigate(['gene-expression', 'array', 'query'], {
                queryParams: {
                    keyword: this.product.productID,
                    productType: "gx",
                    productSubtype: "gx"
                }
            });
            return;
        }

        let chipActive: boolean = null;
        for (const chip of this.chipDetails) {
            if (chip.name === chipName) {
                chip.active = !chip.active;
                chipActive = chip.active;
            } else {
                chip.active = false;
            }
        }

        this.selectedChip = chipActive ? chipName : null;

        if (this.selectedChip === 'Citations') {
            void this.loadBiozModule();
        }

        if (this.selectedChip === 'Details') {
            void this.loadDetailsModule();
        }

        if (this.selectedChip === 'Related products') {
            void this.loadRelatedProductsModule();
        }

    }

    isDisplayingSection(chipName: string): boolean {
        return this.selectedChip === chipName;
    }

    isDisplayingAnySection(): boolean {
        return this.selectedChip != null;
    }

    addToCart(): void {
        if (this.productSiteRegionService.isFisherSci()) {
            this.addToCartForFS();
        } else {
            this.priceService.getPreloadedPricing(this.selectedCatalogNum).subscribe({
                next: (pricingData) => {
                    this._addToCart(pricingData);
                },
                error: (err) => {
                    console.log(err);
                }
            });
        }
    }

    private addToCartForFS() {
        const gene = this.product.geneSymbol ? this.product.geneSymbol[0] : '';
        const item: FisherSciCartItem = {
            'partNumber': this.selectedCatalogNum,
            'quantity': 1,
            'uom': 'EA',
            'assayId': this.product?.productID,
            'geneSymbol': gene
        };
        const itemList: FisherSciCartItem[] = [];
        itemList.push(item);

        const cart: FisherSciCartRequest = {
            'addToCartFrom': 'Magellan',
            'itemList': itemList
        }
        this.fsCartService.addToCartSubscriberForFS(cart).subscribe({
                next: this.handleResponse,
                error: (() => {
                    this.cartResponseMessage = 'Unable to add to cart';
                    this.isAddableToCart = false;
                })
            }
        );

    }
    private handleResponse = (res) => {
        this.cartResponseMessage = res.cartResponseMessage;
        this.isAddableToCart = res.isCartAddSuccessful;
    }

    private _addToCart(pricingData: PricingModel) {
        const id = this.product.productID;

        const row = {
            price: pricingData.getFinalPrice(this.isUserLoggedIn),
            catalogNumber: this.selectedCatalogNum
        }

        const lineItems = this.tfCartService.getItems(id, row);
        const cart = this.tfCartService.getCart(lineItems);

        this.tfCartService.addToCartSubscriber(cart);

        // Analytics

        const productForAnalytics = {
            sku: this.selectedCatalogNum,
            aid: id,
            catalogNumber: this.selectedCatalogNum,
            quantity: 1,
            uom: this.selectedSize.label,
            productSubType : 'ge',
            price: pricingData.getFinalPrice(this.isUserLoggedIn) ,
            loc: 'Result row'
        };

        this.analyticsService.triggerAddToCart(productForAnalytics);

    }

    onClose(chipName: string) {
        this.toggleResultSection(chipName);
    }

    resetScrollTo(chipName: string | undefined) {
        this.scrollToTab = chipName;
    }

    popoverWarningTemplate(ref1, ref2): TemplateRef<any> {
        return this.storeService.getSelectedProductsCount() >= 3 ? ref2 : ref1;
    }

    handleCheckChange(event: Event | any, popover: NgbPopover) {
        if (event.checked) {
            this.storeService.addSelectedProduct(this.product);
            if (popover)
                popover.open();
        } else {
            this.storeService.removeSelectedProduct(this.product);
        }
    }

    checkChipVisibility() {
        if (typeof this.relatedArraysCount !== "undefined" && this.relatedArraysCount > 0) {
            this.showRelatedArraysChip = true;
        }
    }

    onItemAddedToListHandler() {
        this.tfNotificationsService.showSuccess("Product added to shared list");
    }

    getDyeOptions(): Dropdown[] {
        const opts = this.storeService.getDyeOptionsGEAssays(this.product.dyeSizeData);
        return opts ? opts : [];
    }

    getSizeOptions(): Dropdown[] {
        const opts = this.storeService.getSizeOptions(this.product.dyeSizeData, this.selectedDye.value, this.product.availability);
        return opts ? opts : [];
    }

    onDyeChange(option: Dropdown): void {
        this.isAddableToCart= true;

        this.selectedDye = option;

        if (option.value === this.product.defaultDye) {
            this.selectedSize = this.getSizeOptions().find(obj => obj.value === this.product.defaultCatalogNum);
        } else {
            this.selectedSize = this.getSizeOptions()[0];
        }

        this.selectedCatalogNum = this.selectedSize.value;
        this.selectedAvailabity = this.selectedSize.availability;
        this.storeService.selectCatalogNumber(this.product, this.selectedCatalogNum);

        this.product.selectedDye = option.value;
        this.product.selectedSize = this.selectedSize.label;
        this.product.selectedAvailability = this.selectedSize.availability;
        this.setListItem();
        this.storeService.notifyChanges();

    }

    onSizeChange(option: Dropdown): void {
        this.isAddableToCart= true;
        this.selectedSize = option;
        this.selectedCatalogNum = this.selectedSize.value;
        this.selectedAvailabity = this.selectedSize.availability;
        this.storeService.selectCatalogNumber(this.product, this.selectedCatalogNum);
        this.storeService.selectSize(this.product, this.selectedSize.label);
        this.product.selectedAvailability = this.selectedSize.availability;
        this.setListItem();
        this.storeService.notifyChanges();
    }

    onClickTranscript() {
        if (this.isTranscriptCountGreaterThan0()) {
            this.chipDetails.forEach(chipDetail => {
                if (chipDetail.name === "Details") {
                    this.selectedChip = chipDetail.name;
                    chipDetail.active = true;
                    this.scrollToTab = "Interrogated Sequences";
                }
            })
            this.tabs.forEach(tab => {
                if (tab.name === "Interrogated Sequences") tab.active = true;
                if (tab.name !== "Interrogated Sequences" && tab.active === true) tab.active = false;
            })
        }
        void this.loadDetailsModule();
    }

    productIdClick(productId): void {
        this.analyticsService.productHeaderLinkClicked(productId, this.index + 1);
    }

    getProductUrl(): string {
        if (this.isFisherSci === true) {
            return `/taqman-gene-expression/product/${this.product.productID}?CID=&ICID=&subtype=ge_all&pluginName=fishersci`;
        }
        return `/taqman-gene-expression/product/${this.product.productID}?CID=&ICID=&subtype=`;
    }

    getContentToCopyToClipboard(): string {
        return this.selectedCatalogNum + " " + this.product.productID;
    }

    getCopyToClipboardOptions(): TfCopyPayloadOptions {
        return {
            helperDescription: "<strong>Select to copy catalog number and Assay ID to clipboard.</strong><p>Both are required for ordering selected assay configuration.</p>",
            showHelper: true,
            showConfirmation: true,
            showSuccess: true,
            successMessage: "Catalog number and Assay ID successfully copied to clipboard."
        }
    }

    onAssayIdMouseUp() {
        const selection = this.document.getSelection().toString().trim().toLowerCase();
        if (selection.length > 3 &&
            this.getContentToCopyToClipboard().toLowerCase().indexOf(selection) >= 0) {
            const selectionArr = this.getContentToCopyToClipboard().split(" ");
            this.showAssayIdCopyToClipboard = selectionArr[1].toLowerCase().indexOf(selection) >= 0;
            this.showCatalogNumberCopyToClipboard = selectionArr[0].toLowerCase().indexOf(selection) >= 0;
        }
    }

    hideCopyToClipboardWidget(delay: number) {
        if (this.showAssayIdCopyToClipboard || this.showCatalogNumberCopyToClipboard) {
            if (this.timeOutHolder != null) {
                clearTimeout(this.timeOutHolder);
                this.timeOutHolder = null;
            }
            if (!delay) {
                this.showAssayIdCopyToClipboard = false;
                this.showCatalogNumberCopyToClipboard = false;
            } else {
                this.timeOutHolder = setTimeout(() => {
                    this.showAssayIdCopyToClipboard = false;
                    this.showCatalogNumberCopyToClipboard = false;
                    this.timeOutHolder = null;
                }, delay);
            }
        }
    }

    onCopied(event) {
        if (event === false) {
            this.hideCopyToClipboardWidget(100);
        } else {
            this.hideCopyToClipboardWidget(5000);
        }
    }

    compareDropdown(a: Dropdown, b: Dropdown): boolean {
        return a?.value === b?.value;
    }

    getTranscriptsCount() {
        return this.isTranscriptCountGreaterThan0() ? this.product.transcripts : "-";
    }

    isTranscriptCountGreaterThan0(): boolean {
        return parseInt(this.product.transcripts, 10) > 0;
    }

    getGeneSymbolAsString(): string {
        return Array.isArray(this.product.geneSymbol) ? this.product.geneSymbol.join(", ") : "";
    }

    displayRibbon() {
        return this.product?.recommended?.toLowerCase() == "yes";
    }

    addToCardFSClasses(): string[] {
        if (!this.isFisherSci) {
            return [];
        } else {
            return ['d-flex', 'align-items-center', 'add-to-cart-ctnr-fs', 'mb-2'];
        }
    }

    async loadDetailsModule(): Promise<void> {

        const {TfResultRowDetailComponent} = await import("../../modules/details");

        this.detailsViewContainer.clear();

        const component = this.detailsViewContainer.createComponent(TfResultRowDetailComponent);

        component.instance.index = this.index;
        component.instance.product = this.product;
        component.instance.scrollToTab = this.scrollToTab;
        component.instance.tabs = this.tabs;

        const resetScrollToSubscription = component.instance.resetScrollTo.subscribe(($event) => {
            this.resetScrollTo($event);
        });

        this.subscriptions.add(resetScrollToSubscription);

    }

    async loadRelatedProductsModule(): Promise<void> {

        const {TfRelatedProductsComponent} = await import("../../modules/related-products");

        this.relatedProductsViewContainer.clear();

        const component = this.relatedProductsViewContainer.createComponent(TfRelatedProductsComponent);
        component.instance.id = this.product.productID;
        component.instance.species = this.product.species;
        component.instance.index = this.index;

    }

    async loadBiozModule(): Promise<void> {

        const {TfBiozInfoComponent} = await import("../../../../../modules/bioz");

        this.biozViewContainer.clear();

        const component = this.biozViewContainer.createComponent(TfBiozInfoComponent);

        component.instance.productId = this.product.productID;

    }

    getCitationsLabel(): string {

        if (this.citationsCount === 1) {
            return this.citationsCount + ' Citation';
        }

        if (this.citationsCount > 1) {
            return this.citationsCount + ' Citations';
        }

        return 'Citations';

    }

    getAmpliconCount(ampliconLength): number | string {
        return ampliconLength > 0 ?  ampliconLength : "-";
    }

}
